import 'css-chunksrc/client/pages/projectPage/timeSheetPage/detailsToggle/styles.scss';export default {
  "detailsToggle": "_detailsToggle_1qxd1_1",
  "label": "_label_1qxd1_12"
};